import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import { getFullName } from '@hellodarwin/core/lib/features/helpers';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Delete from '@hellodarwin/icons/dist/icons/Delete';
import DatePicker from 'antd/es/date-picker';
import Form from 'antd/es/form';
import FormItem from 'antd/es/form/FormItem';
import Select from 'antd/es/select';
import dayjs from 'dayjs';
import { useTheme } from 'styled-components';
import GenericFormFillingDrawer from './generic-form-filling-drawer';
const GinStepMeetingApplicationDrawer = ({ meetingName, meetingApplication, isMeetingDrawerOpen, setIsMeetingDrawerOpen, handleSubmitMeeting, isLoading, handleDeleteMeeting, admins, contacts, }) => {
    const { t } = useTranslations();
    const theme = useTheme();
    const [form] = Form.useForm();
    return (_jsx(GenericFormFillingDrawer, { titleText: meetingName, loading: isLoading, open: isMeetingDrawerOpen, onSave: form.submit, onClose: () => {
            form.resetFields();
            setIsMeetingDrawerOpen(false);
        }, width: 600, children: _jsxs(Form, { form: form, layout: "vertical", initialValues: meetingApplication, onFinish: (values) => {
                handleSubmitMeeting(values);
            }, onFinishFailed: (errorInfo) => {
                console.warn('Validation failed:', errorInfo);
            }, children: [_jsx(FormItem, { name: "contact_id", label: "Contact ID", rules: [
                        {
                            required: true,
                            message: 'Contact ID is required',
                        },
                    ], initialValue: (meetingApplication === null || meetingApplication === void 0 ? void 0 : meetingApplication.contact_id) || undefined, children: _jsx(Select, { placeholder: t('gin_steps|company_contact'), style: { width: '100%' }, value: meetingApplication === null || meetingApplication === void 0 ? void 0 : meetingApplication.contact_id, onSelect: (contact_id) => {
                            form.setFieldValue(['contact_id'], contact_id);
                        }, options: contacts === null || contacts === void 0 ? void 0 : contacts.map((contact) => ({
                            value: contact.contact_id,
                            label: getFullName(contact.first_name, contact.last_name),
                        })) }) }), admins && (_jsx(FormItem, { name: "admin_id", label: "Admin ID", rules: [
                        {
                            required: true,
                            message: 'Admin ID is required',
                        },
                    ], initialValue: (meetingApplication === null || meetingApplication === void 0 ? void 0 : meetingApplication.admin_id) || undefined, children: _jsx(Select, { placeholder: t('gin_steps|admin_contact'), style: { width: '100%' }, value: meetingApplication === null || meetingApplication === void 0 ? void 0 : meetingApplication.admin_id, onSelect: (admin_id) => {
                            form.setFieldValue(['admin_id'], admin_id);
                        }, showSearch: true, filterOption: (input, option) => {
                            var _a, _b;
                            return (_b = (_a = option === null || option === void 0 ? void 0 : option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(input.toLowerCase())) !== null && _b !== void 0 ? _b : false;
                        }, options: admins.map((admin) => ({
                            value: admin.admin_id,
                            label: admin.first_name + ' ' + admin.last_name,
                        })) }) })), _jsx(FormItem, { name: "meeting_date", label: t('gin_steps|meeting_date'), rules: [
                        {
                            required: true,
                            message: t('gin_steps|meeting_date_required'),
                        },
                    ], initialValue: (meetingApplication === null || meetingApplication === void 0 ? void 0 : meetingApplication.meeting_date) || undefined, getValueProps: (value) => ({ value: value ? dayjs(value) : null }), children: _jsx(DatePicker, {}) }), _jsx(FormItem, { name: "meeting_medium", label: t('gin_steps|meeting_medium'), rules: [
                        {
                            required: true,
                            message: t('gin_steps|meeting_medium_required'),
                        },
                    ], initialValue: (meetingApplication === null || meetingApplication === void 0 ? void 0 : meetingApplication.meeting_medium) || undefined, children: _jsx(Select, { options: [
                            { value: 'video', label: 'Video' },
                            { value: 'phone', label: 'Phone' },
                            { value: 'in_person', label: 'In Person' },
                        ] }) }), !!handleDeleteMeeting && (_jsx(Button, { size: "circle", defaultStyle: theme.colors.white_1, onClick: () => {
                        handleDeleteMeeting();
                    }, children: _jsx(Delete, { size: 16 }) }))] }) }));
};
export default GinStepMeetingApplicationDrawer;
